import './bricks.scss'

import { FC, useEffect, useState } from 'react'
import { Card, Image } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { LIFERAY_URL } from 'src/config'
import { NAV_TO_VOUCHER_DETAIL } from 'src/navigation'
import { voucher_list_box, voucher_t } from 'src/types'

export const ListBox: FC<voucher_list_box> = ({ vouchers }: voucher_list_box) => {
  const navigate = useNavigate()
  /**
   * Use State
   */
  const [vouchs, set_vouchs] = useState<voucher_t[]>()

  /**
   * Use Effect
   */
  useEffect(() => {
    if (vouchers) {
      set_vouchs(vouchers || [])
    }
  }, [vouchers])

  /**
   * Render functions
   */
  const render_voucher = (vouch: voucher_t) => (
    <Card
      className="mt-0 mb-5 rounded-0 border-0 shadow grid-block height-voucher"
      onClick={() => navigate(`${NAV_TO_VOUCHER_DETAIL}?voucher-number=${vouch?.idPartner}`)}
    >
      <div className="grid-block-height-voucher">
        <Image
          fluid
          src={
            vouch?.bannerSmallImage?.contentUrl?.startsWith('/')
              ? `${LIFERAY_URL}${vouch?.bannerSmallImage?.contentUrl}`
              : vouch?.bannerSmallImage?.contentUrl
          }
        />
      </div>
      <div className="pt-2 pb-2 pl-3 grid-block-height-voucher-description">
        <div className="font-12 c-7f7f7f uppercase">{vouch?.category}</div>
        <div className="mt-1 font-18">{vouch?.title}</div>
      </div>
    </Card>
  )

  return (
    <main className="grid-wrapper">
      {vouchs?.map((vouch, idx) => (
        <div key={idx}>{render_voucher(vouch)}</div>
      ))}
    </main>
  )
}
